import { Locale } from "../../../../types";

export const getLangFromLocale = (locale: Locale): string => locale.split('-')[0];